import { type VariantProps, cva } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

export { default as CarouselItemSelector } from './CarouselItemSelector.vue';

export const carouselItemSelectorContainerStyles = cva(
	'flex h-[2px] max-w-[54.75px] transition-all duration-200 md:max-w-[60px]',
	{
		variants: {
			variant: {
				dark: 'bg-primary/20 hover:bg-primary/40',
				white: 'bg-white/20 hover:bg-white/40'
			},
			dynamicWidth: {
				true: 'w-full',
				false: 'w-[54.75px] md:w-[60px]'
			},
			size: {
				default: 'w-[54.75px] md:w-[60px]',
				sm: 'w-8 max-w-[36px] md:w-[3.75rem] md:max-w-[3.75rem]'
			}
		},
		defaultVariants: {
			variant: 'white',
			size: 'default'
		}
	}
);

export const carouselItemSelectorBarStyles = cva('h-full', {
	variants: {
		variant: {
			dark: 'bg-primary',
			white: 'bg-white'
		}
	},
	defaultVariants: {
		variant: 'white'
	}
});

export type CarouselGenericActionVariants = VariantProps<
	typeof carouselItemSelectorContainerStyles
>;

export type BaseProps = {
	class?: HTMLAttributes['class'];
	active: boolean;
	delay: number;
	variant?: CarouselGenericActionVariants['variant'];
};

export type WithSize = BaseProps & {
	size: CarouselGenericActionVariants['size'];
	dynamicWidth?: never;
};

export type WithDynamicWidth = BaseProps & {
	dynamicWidth: number;
	size?: never;
};

export type CarouselItemSelectorProps = WithSize | WithDynamicWidth;
